import { Check, Circle } from 'lucide-react';
import { PASSWORD_RULES } from '../../lib/passwordRules';

// Live checklist under a password field, for the dark glass auth screens.
// Shown before the first keystroke: a tester couldn't tell why Continue was
// greyed out. Met rules differ by icon as well as colour.
const PasswordHints = ({ id, password }) => (
  <ul id={id} className="mt-2 space-y-1">
    {PASSWORD_RULES.map((rule) => {
      const met = rule.test(password);
      return (
        <li
          key={rule.id}
          className="flex items-center gap-2 text-xs"
          style={{ color: met ? '#fff' : 'rgba(255,255,255,0.7)' }}
        >
          {met ? <Check size={14} aria-hidden="true" /> : <Circle size={14} aria-hidden="true" />}
          <span>{rule.label}</span>
          <span className="sr-only">{met ? '(done)' : '(needed)'}</span>
        </li>
      );
    })}
  </ul>
);

export default PasswordHints;
